import { Typography } from '@mui/material'
import { RendererProps, resolveDynamicString } from 'components/a2ui/types'
import { SafeMarkdown } from 'components/core/markdown'
import { getByPointer } from 'lib/a2ui/resolver'
import { FC } from 'react'

type TextRendererProps = Pick<RendererProps, 'component' | 'dataModel'>

export const TextRenderer: FC<TextRendererProps> = ({ component, dataModel }) => {
    if (component.component.oneofKind !== 'text') return null

    const text = resolveDynamicString(component.component.text.text, dataModel, getByPointer)

    if (component.component.text.markdown) {
        return <SafeMarkdown>{text}</SafeMarkdown>
    }

    return <Typography variant="body1">{text}</Typography>
}
